[
  {
    "id": 1,
    "header": "Talk to a Lab Optimization Expert",
    "subheader": "Connect with our consultants to discuss your lab's challenges and explore whether Lab Consultancy services could be a fit.",
    "button": "Schedule a Call",
    "href": "https://info.biomerieux.com/clin_us_2025_lab-optimization-consultancy_talk-to-sales"
  },
  {
    "id": 2,
    "header": "Lab Consultancy at a Glance",
    "subheader": "Get a quick overview of our services, approach, and how we help organizations like yours succeed.",
    "button": "Download Brochure",
    "href": "https://info.biomerieux.com/rs/315-VKA-657/images/clin_us_page_PRN-056003-Rev.01.A_Lab-Optimization-Brochure.pdf"
  },
  {
    "id": 3,
    "header": "Discover How We Help Optimize Labs",
    "subheader": "Browse our full service offering, read customer success stories, and meet our team of consultants.",
    "button": "Explore Our Services",
    "href": "https://info.biomerieux.com/clin_us_2024_lab-consultancy"
  }
]